import React from 'react'

import formatValue from '../../../../utils/valueFormatting'

export default ({value, type}) => (
    <div className="tableCell is-size-7">{type === 'string' ? value : formatValue(value)}</div>
)